import axios from "../../util/axios";

const PREFIX_URI = "/luqiao/project";

export default {
    /** 查询列表 */
    list: (data) => axios.get({url: `${PREFIX_URI}/list`, data: data}),

    /** 保存 */
    saveSubmit:  (data) => axios.post({url: `${PREFIX_URI}/saveSubmit`, data: data}),

    /** 删除 */
    delete: (id) => axios.get({url: `${PREFIX_URI}/delete`, data: {id: id}}),

    /** 查询详情 */
    findById: (id) => axios.get({url: `${PREFIX_URI}/findById`, data: {id: id}}),

    /** 查询项目工地 */
    querySiteByProjectId: (projectId) => axios.get({url: `${PREFIX_URI}/querySiteByProjectId`, data: {projectId: projectId}}),

    /** 查询项目班级 */
    queryClassmateByProjectId: (projectId) => axios.get({url: `${PREFIX_URI}/queryClassmateByProjectId`, data: {projectId: projectId}}),

    /** 查询项目员工 */
    queryWorkersByProjectId: (projectId) => axios.get({url: `${PREFIX_URI}/queryWorkersByProjectId`, data: {projectId: projectId}}),
    /** 查询所有配置 */
    queryAllAttendConfig: () => axios.get({url: `${PREFIX_URI}/queryAllAttendConfig`}),
}